import React from 'react';
import PropTypes from 'prop-types';
import OurTeamLayout from './OurTeamLayout';

import {
  MainOurTeam,
  WrapperOurTeam,
  HeaderOurTeam,
  TitleOurTeam,
  SummaryOurTeam
} from './style';

const OurTeam = ({ className, title, text, dataTeam }) => (
  <MainOurTeam className={className}>
    <WrapperOurTeam>
      {(title || text) && (
        <HeaderOurTeam>
          {title && <TitleOurTeam>{title}</TitleOurTeam>}
          {text && <SummaryOurTeam>{text}</SummaryOurTeam>}
        </HeaderOurTeam>
      )}
      <OurTeamLayout dataTeam={dataTeam} />
    </WrapperOurTeam>
  </MainOurTeam>
);

OurTeam.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  dataTeam: PropTypes.arrayOf(
    PropTypes.shape({
      person: PropTypes.string,
      job: PropTypes.string
    })
  )
};

export default OurTeam;
